import { render, staticRenderFns } from "./PsikologisHasil.vue?vue&type=template&id=3667e9e4"
import script from "./PsikologisHasil.vue?vue&type=script&setup=true&lang=js"
export * from "./PsikologisHasil.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports